import * as React from 'react';

import { PrimitiveTabs } from 'components';
import { useCatalogAction, useCatalogValue } from 'context';

import { CatalogBaseInfo } from './base-info';
import { CatalogFilesInfo } from './files-info';
import { CatalogSeoInfo } from './seo-info';

const CatalogFormTabs = () => {
  const { step = 1 } = useCatalogValue();
  const action = useCatalogAction();

  return (
    <PrimitiveTabs
      items={[
        {
          key: '1',
          label: 'اطلاعات اولیه',
          children: <CatalogBaseInfo />,
        },
        {
          key: '2',
          label: 'مدیریت مستندات',
          children: <CatalogFilesInfo />,
          disabled: step < 2,
        },
        {
          key: '3',
          label: 'تنظیمات سئو',
          children: <CatalogSeoInfo />,
          disabled: step < 3,
        },
      ]}
      activeKey={step.toString()}
      onChange={activeKey => {
        action({
          type: 'UPDATE_CATALOG_STEP',
          payload: {
            step: +activeKey as typeof step,
          },
        });
      }}
    />
  );
};

export { CatalogFormTabs };
